import { toast } from 'sonner';

import { Button, buttonVariants } from '@/components/ui/button';

const TestingGround = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <Button
        className={buttonVariants({ variant: 'destructive' })}
        onClick={() => {
          // throw new Error('Test error for Sentry');

          toast.error('Test toast');
        }}
      >
        Test error
      </Button>
    </div>
  );
};

export default TestingGround;
